import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {Body} from "@khanacademy/wonder-blocks-typography";

import GutterDecorator from "../../gutter-decorator.tsx";

export default function ListItemNode(
    props: RenderElementProps,
): React.ReactElement {
    const {attributes, element, children} = props;

    return (
        <Body {...attributes} tag="li" style={styles.item}>
            <GutterDecorator element={element}>{children}</GutterDecorator>
        </Body>
    );
}

const styles = StyleSheet.create({
    item: {
        display: "list-item",
        paddingBlockEnd: 0,
        marginBlockEnd: 0,
    },
});
